module.exports = __webpack_public_path__ + "static/media/ic_sidemenu_testing.b5f69260.svg";